import { useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useScrollToHash = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const hashElement = useMemo(() => {
    let hash = location.hash;
    const removeHashCharacter = (str) => {
      const result = str.slice(1);
      return result;
    };

    if (hash) {
      let element = document.getElementById(removeHashCharacter(hash));
      return element;
    } else {
      return null;
    }
  }, [location]);

  useEffect(() => {
    if (hashElement) {
      hashElement.scrollIntoView({
        behavior: "smooth",
        inline: "nearest",
      });
      navigate(location.pathname)
    }
  }, [hashElement, location.pathname, navigate]);

  // return null;
};

// export default ScrollToHashElement;
